import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import reportsData from './reports.json';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  title = '';
  isAdmin = false;
  loading = false;
  showingDownloadData = false;
  reports;
  dailyReports = [];
  annualReports = [];
  reportType;
  fileTypes = [
    {
      name: 'XLS',
      value: 'XLS'
    },
    {
      name: 'PDF',
      value: 'PDF'
    }
  ];
  chutes;
  mainChutes;
  reserveChutes;
  drogueChutes;
  mainChutesUnfiltered;
  reserveChutesUnfiltered;
  drogueChutesUnfiltered;
  jumpers;
  inactiveJumpers;
  originalJumpers = [];
  spotters;
  bases;
  qualifications;
  years = [];
  status = [
    {
      name: 'Active',
      value: 'Active'
    },
    {
      name: 'Inactive',
      value: 'Inactive'
    }
  ];

  selectedFileType = {
    name: '',
    value: ''
  };
  selectedBase = {
    id: '',
    value: '',
    baseId: ''
  };
  selectedStatus = {
    name: '',
    value: ''
  };
  selectedJumper = {
    firstName: '',
    lastName: '',
    id: ''
  };
  selectedQualification = {
    Acronym: '',
    value: ''
  };
  selectedYear = {
    name: '',
    value: ''
  };
  selectedChute = {
    Base: '',
    name: '',
    chutename: 'ALL',
    chutetype: 0,
    value: ''
  };
  selectedChuteStyle = {
    name: 'Main',
    value: 'Main',
    chutetype: 1
  };

  showingSpotters = false;
  showingReports = false;
  showingJumpers = false;
  showingBases = false;
  showingQualifications = false;
  showingYear = false;
  showingChutes = false;
  showingDashboard = true;
  showingAllJumpers = false;
  showingStatus = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {
    this.reports = reportsData.reports;
    this.reports.forEach((report) => {
      if (report.period === 'daily') {
        this.dailyReports.push(report);
      } else {
        this.annualReports.push(report);
      }
    });
    this.route.params.subscribe((params) => {
      if (params.type) {
        this.showingDashboard = false;
      } else {
        this.showingDashboard = true;
      }
      this.reportType = params.type;
      this.showingStatus = params.status;
      this.showingJumpers = params.jumpers;
      this.showingAllJumpers = params.alljumpers;
      this.showingBases = params.bases;
      this.showingQualifications = params.qualifications;
      this.showingYear = params.year;
      this.showingSpotters = params.spotters;
      this.showingChutes = params.chutes;
      this.title = params.title;
      this.years = [];
      if (params.allYears) {
        this.years = [
          {
            name: 'All Years',
            value: 'all'
          }
        ];
      }
      for (let year = new Date().getFullYear(); year > 2003; year--) {
        this.years.push({ name: year.toString(), value: year.toString() });
      }
    });

    this.clearForm();
  }

  clearForm = () => {
    this.selectedFileType = {
      name: '',
      value: ''
    };
    this.selectedBase = {
      id: '',
      value: '',
      baseId: ''
    };
    this.selectedStatus = {
      name: '',
      value: ''
    };
    this.selectedJumper = {
      firstName: '',
      lastName: '',
      id: ''
    };
    this.selectedQualification = {
      Acronym: '',
      value: ''
    };
    this.selectedYear = {
      name: '',
      value: ''
    };
    this.selectedChute = {
      Base: '',
      name: '',
      chutename: 'ALL',
      chutetype: 0,
      value: ''
    };
    this.selectedChuteStyle = {
      name: 'Main',
      value: 'Main',
      chutetype: 1
    };
  };

  async ngOnInit() {
    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    let role = this.userInfo.role;
    let baseCode = this.userInfo.basecode;

    // check if the user is an admin
    if (role === 'admin' || role === 'baseadmin' || role === 'sysadmin') {
      this.isAdmin = true;
    }

    // get data to populate form fields
    let bases = await axios.get(
      environment.API_URL + '/base/dropdown/main',
      options
    );
    this.bases = bases.data;
    this.bases = this.sort(this.bases, 'text');

    let jumpers = await axios.get(environment.API_URL + '/jumpers', options);
    this.jumpers = jumpers.data.value;

    this.inactiveJumpers = [...this.jumpers];

    // filter out all the inactive jumpers
    this.inactiveJumpers = this.inactiveJumpers.filter((jumper) => {
      return jumper.activeStatus !== true;
    });

    // parse inactive jumper data for friendly display
    for (let x = 0; x < this.inactiveJumpers.length; x++) {
      this.inactiveJumpers[x].fullName =
        this.inactiveJumpers[x].lastName + ', ' + this.inactiveJumpers[x].firstName;
      this.inactiveJumpers[x].friendly =
        this.inactiveJumpers[x].fullName + ' | ' + this.inactiveJumpers[x].base.code;
    }

    // sort inactive jumpers by last name alphabetically
    this.inactiveJumpers = this.sort(this.inactiveJumpers, 'lastName');

    // now filter out just the active jumpers
    this.jumpers = this.jumpers.filter((jumper) => {
      return jumper.activeStatus === true;
    });

    // parse jumper data for friendly display
    for (let x = 0; x < this.jumpers.length; x++) {
      this.jumpers[x].fullName =
        this.jumpers[x].lastName + ', ' + this.jumpers[x].firstName;
      this.jumpers[x].friendly =
        this.jumpers[x].fullName + ' | ' + this.jumpers[x].base.code;
    }

    // sort jumpers by last name alphabetically
    this.jumpers = this.sort(this.jumpers, 'lastName');
    this.originalJumpers = this.jumpers;

    this.spotters = this.jumpers.filter((jumper) => {
      return ((jumper.spotter === 'Spotter' || jumper.spotter === 'Trainee') && (jumper.activeStatus === true)); 
    });

    let qualifications = await axios.get(
      environment.API_URL + '/Quals',
      options
    );
    this.qualifications = qualifications.data.value;
    this.qualifications = this.qualifications.filter((qual) => {
      return qual.active === true;
    });
    this.qualifications = this.sort(this.qualifications, 'title');
    this.qualifications.unshift({
      title: 'All Quals',
      value: 'All Quals',
      Acronym: 'ALL'
    });
    let mainChutes = await axios.get(
      environment.API_URL + '/chutemain?limit=999999',
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.mainChutes = mainChutes.data.value;
    this.mainChutes = this.mainChutes.filter((chute) => {
      return chute.inService === true;
    });
    let drogueChutes = await axios.get(
      environment.API_URL + '/chutedrogue?limit=999999',
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.drogueChutes = drogueChutes.data.value;
    this.drogueChutes = this.drogueChutes.filter((chute) => {
      return chute.inService === true;
    });
    let reserveChutes = await axios.get(
      environment.API_URL + '/chutereserve?limit=999999',
      {
        headers: { Authorization: 'Bearer ' + this.token }
      }
    );
    this.reserveChutes = reserveChutes.data.value;
    this.reserveChutes = this.reserveChutes.filter((chute) => {
      return chute.inService === true;
    });

    let chutes = this.mainChutes.concat(
      this.drogueChutes.concat(this.reserveChutes)
    );

    chutes.forEach((chute) => {
      if (chute.main) {
        chute.style = 'Main';
        chute.name = chute.main;
        chute.chutename = chute.main;
        chute.chutetype = 1;
      }
      if (chute.drogue) {
        chute.style = 'Drogue';
        chute.name = chute.drogue;
        chute.chutename = chute.drogue;
        chute.chutetype = 3;
      }
      if (chute.reserve) {
        chute.style = 'Reserve';
        chute.name = chute.reserve;
        chute.chutename = chute.reserve;
        chute.chutetype = 2;
      }
      chute.active = chute.inService ? 'Yes' : 'No';
    });

    this.drogueChutes = this.sort(this.drogueChutes, 'name');
    this.drogueChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 3
    });
    this.drogueChutesUnfiltered = this.drogueChutes;
    this.mainChutes = this.sort(this.mainChutes, 'name');
    this.mainChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 1
    });
    this.mainChutesUnfiltered = this.mainChutes;
    this.reserveChutes = this.sort(this.reserveChutes, 'name');
    this.reserveChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 2
    });
    this.reserveChutesUnfiltered = this.reserveChutes;
  }

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  goToDash = () => {
    this.clearForm();
    this.showingDownloadData = false;
    this.showingDashboard = true;
    this.router.navigate(['reports']);
  };

  selectReport = (report) => {
    this.clearForm();
    this.showingDashboard = false;
    this.router.navigate([report.route, report.params]);
  };

  selectStatus = (status) => {
    this.selectedStatus = status;

    if (this.selectedStatus.value === 'Active' || this.selectedStatus.value === '') {
      this.jumpers = this.originalJumpers;
    } else {
      this.jumpers = this.inactiveJumpers;
    }

    // filter jumpers by base
    let filteredJumpers = [];
    this.jumpers.forEach((jumper) => {
      if (jumper.baseId === this.selectedBase.baseId) {
        filteredJumpers.push(jumper);
      }
    });

    // dedupe jumpers
    let uniqueJumpers = [...new Set(filteredJumpers)];
    this.jumpers = uniqueJumpers;
    this.spotters = this.jumpers.filter((jumper) => {
      return ((jumper.spotter === 'Spotter' || jumper.spotter === 'Trainee') && (jumper.activeStatus === true)) ; 
    });
  }

  selectBase = (base) => {
    this.selectedBase = base;

    if (this.selectedStatus.value === 'Active' || this.selectedStatus.value === '') {
      this.jumpers = this.originalJumpers;
    } else {
      this.jumpers = this.inactiveJumpers;
    }

    // filter jumpers by base
    let filteredJumpers = [];
    this.jumpers.forEach((jumper) => {
      if (jumper.baseId === this.selectedBase.baseId) {
        filteredJumpers.push(jumper);
      }
    });

    // dedupe jumpers
    let uniqueJumpers = [...new Set(filteredJumpers)];
    this.jumpers = uniqueJumpers;

    this.spotters = this.jumpers.filter((jumper) => {
      return ((jumper.spotter === 'Spotter' || jumper.spotter === 'Trainee') && (jumper.activeStatus === true)); 
    });

    // filter chutes by base
    if (this.selectedChute.Base !== base.baseCode) {
      this.selectedChute = {
        Base: base.baseCode,
        name: 'ALL Parachutes',
        value: 'ALL',
        chutename: 'ALL',
        chutetype: this.selectedChuteStyle.chutetype
      };
    }
    this.mainChutes = this.mainChutesUnfiltered.filter((chute) => {
      return chute.Base === base.baseCode;
    });
    this.mainChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 1
    });
    this.reserveChutes = this.reserveChutesUnfiltered.filter((chute) => {
      return chute.Base === base.baseCode;
    });
    this.reserveChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 2
    });
    this.drogueChutes = this.drogueChutesUnfiltered.filter((chute) => {
      return chute.Base === base.baseCode;
    });
    this.drogueChutes.unshift({
      name: 'ALL Parachutes',
      value: 'ALL',
      chutename: 'ALL',
      chutetype: 3
    });
  };

  generateReport = async () => {
    this.loading = true;
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    try {
      let request = {
        basename: this.selectedBase.value,
        report: this.reportType,
        reportUrl: environment.REPORT_URL,
        reporttype: this.selectedFileType.value,
        year: this.selectedYear.value,
        BaseName: this.selectedBase.value,
        Qual: this.selectedQualification.Acronym,
        JumperIdlist: this.getJumperIds(),
        baseId: this.selectedBase.baseId,
        chutename: this.selectedChute.chutename,
        chutetype: this.selectedChuteStyle.chutetype,
        JumperName:
          this.selectedJumper.lastName + ', ' + this.selectedJumper.firstName,
        jumperId: this.selectedJumper.id,
        status: this.selectedStatus.value
      };
      request = this.cleanRequest(request);
      let report = await axios.post(
        environment.API_URL + '/Reports/getReport',
        request,
        options
      );

      // if error occurred, svc will return "E:" appended with the
      //  error msg
      if (report.data.startsWith('E:')) {
        console.dir(report.data);
        this.loading = false;
        this.toast.show('Unable to generate report', 'error');
      }
      else {
        this.getReport(report.data);
      }
    } catch (error) {
      console.dir(error);
      this.loading = false;
      this.toast.show('Unable to generate report', 'error');
    }
  };

  // remove unnecessary keys from request object (dance around backend)
  cleanRequest = (request) => {
    let report = this.reports.filter((reportData) => {
      return reportData.params.type === this.reportType;
    });
    for (const key in request) {
      if (request.hasOwnProperty(key)) {
        let fields = report[0].params.fields;
        if (fields.includes(key)) {
        } else if (
          key !== 'report' &&
          key !== 'reporttype' &&
          key !== 'reportUrl'
        ) {
          delete request[key];
        }
      }
    }
    return request;
  };

  getJumperIds = () => {
    let ids = [];
    this.jumpers.forEach((jumper) => {
      if (jumper.checked) {
        ids.push(jumper.id);
      }
    });
    return ids;
  };

  getReport = async (url) => {
    // strip any quotes that the backend might have sent -__-
    url.replaceAll('"', '');
    let options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    try {
      let reportRequest = await axios.get(url + '/info', options);
      let report = reportRequest.data;
      if (report.documentReady) {
        window.open(url, '_blank');
        this.loading = false;
      } else {
        setTimeout(() => {
          this.getReport(url);
        }, 1000);
      }
    } catch (error) {
      this.toast.show('Server is unable to generate a report.', 'error');
      this.loading = false;
    }
  };

  downloadData = async () => {
    this.loading = true;
    if (this.selectedFileType.value === 'Incident Info') {
      const options = {
        headers: { Authorization: 'Bearer ' + this.token }
      };
      let url =
        environment.API_URL +
        '/exportIncidentByYear?year=' +
        this.selectedYear.value;
      let data = await axios.get(url, options);
      this.exportToCsv(
        'IncidentInfo' + '-' + this.selectedYear.value + '.csv',
        data.data
      );
      this.loading = false;
    } else if (this.selectedFileType.value === 'Incident Jumper') {
      const options = {
        headers: { Authorization: 'Bearer ' + this.token }
      };
      let url =
        environment.API_URL +
        '/exportJumperIncidentyear?year=' +
        this.selectedYear.value;
      let data = await axios.get(url, options);
      this.exportToCsv(
        'IncidentJumper' + '-' + this.selectedYear.value + '.csv',
        data.data
      );
    }
  };

  isDisabled = () => {
    let disabled = false;
    if (
      (this.showingSpotters || this.showingJumpers) &&
      !this.selectedJumper.firstName.length
    ) {
      disabled = true;
    }
    if (this.showingYear && !this.selectedYear.value.length) {
      disabled = true;
    }
    if (this.showingBases && !this.selectedBase.value.length) {
      disabled = true;
    }
    if (
      this.showingQualifications &&
      !this.selectedQualification.Acronym.length
    ) {
      disabled = true;
    }
    if (!this.selectedFileType.value.length) {
      disabled = true;
    }
    if (this.loading) {
      disabled = true;
    }
    return disabled;
  };

  getBaseLabel = () => {
    let label = 'Base';
    switch (this.reportType) {
      case 'indjumpdif':
        label = 'Home Base';
        break;
      case 'ndtpdatareport':
        label = 'Home Base';
        break;
      case 'chutehistory':
        label = 'Loft';
        break;
      default:
        break;
    }
    return label;
  };

  exportToCsv(filename, rows) {
    if (!rows || !rows.length) {
      return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvData =
      keys.join(separator) +
      '\n' +
      rows
        .map((row) => {
          return keys
            .map((k) => {
              let cell = row[k] === null || row[k] === undefined ? '' : row[k];
              cell =
                cell instanceof Date
                  ? cell.toLocaleString()
                  : cell.toString().replace(/"/g, '""');
              if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`;
              }
              return cell;
            })
            .join(separator);
        })
        .join('\n');

    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    this.loading = false;
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
